import { Action, ActionType } from '../actions/actionTypes';
import STORE from '../store';
import { AppStore } from '../types';

// eslint-disable-next-line default-param-last
const reducer = (state = STORE.app, action: Action): AppStore => {
    switch (action.type) {
        case ActionType.SET_OPEN_ORDERS:
            return { ...state, openOrders: action.payload };
        case ActionType.SET_PRODUCTS:
            return { ...state, products: action.payload };
        case ActionType.SET_TABLES:
            return { ...state, tables: action.payload || [] };
        case ActionType.SET_USER:
            return { ...state, user: action.payload };
        case ActionType.SET_NOT_DISPATCHED_ORDERS:
            return { ...state, notDispatchedOrders: action.payload };
        case ActionType.SET_TABLE_EVENTS:
            return { ...state, tableEvents: action.payload };
        case ActionType.SET_WORKING_HOURS:
            return { ...state, workingHours: action.payload };
        case ActionType.ADD_ORDER:
            return {
                ...state,
                openOrders: state.openOrders.concat(action.payload),
                tables: state.tables.map(t =>
                    t.id === action.payload.tableID ? { ...t, occupied: true } : t
                )
            };
        case ActionType.ADD_TABLE_EVENT:
            return { ...state, tableEvents: state.tableEvents.concat(action.payload) };
        case ActionType.SET_SELECTED_TABLE_ORDER:
            return { ...state, selectedTableOrder: action.payload };
        case ActionType.RESET_STATE:
            return { ...state, selectedTableOrder: null };
        case ActionType.SET_CONNECTION:
            return { ...state, connection: action.payload };
        case ActionType.REMOVE_TABLE_EVENT:
            return {
                ...state,
                tableEvents: state.tableEvents.filter(({ id }) => id !== action.payload)
            };
        case ActionType.SET_ORDER_COMPLETED:
            return {
                ...state,
                openOrders: state.openOrders.filter(
                    ({ id }) => id !== action.payload.id
                ),
                notDispatchedOrders: state.notDispatchedOrders.concat(action.payload)
            };
        case ActionType.SET_ORDER_DELIVERED:
            return {
                ...state,
                notDispatchedOrders: state.notDispatchedOrders.filter(
                    ({ id }) => id !== action.payload.id
                )
            };
        case ActionType.REMOVE_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.filter(
                    ({ key }) => key !== action.payload
                )
            };
        case ActionType.ENQUEUE_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.concat(action.payload)
            };
        case ActionType.FREE_TABLE:
            return {
                ...state,
                tables: state.tables.map(t =>
                    t.id === action.payload ? { ...t, occupied: false } : t
                ),
                selectedTableOrder: null
            };
        default:
            return state;
    }
};

export default reducer;
